//GeneratorFlag:[NoChange]
import PersonRole from './person-role';
import Tenant from './tenant';
import PersonRoleFilter from './person-role-filter';

export default {PersonRole, Tenant, PersonRoleFilter}
export{PersonRole, Tenant, PersonRoleFilter}